import {Optional, User} from 'data/types'
import published from 'utils/published'
import selector, {identitySelector} from 'utils/selector'
import APIService from './APIService'

export default class UserService {
  public user = published<Optional<User>>(null)

  public constructor() {
    this.load()
  }

  private load = async () => {
    this.user.startLoading()
    const result = await APIService.getMe()
    if (result.ok) {
      this.user.publish(result.body)
    }
    this.user.endLoading()
  }
}

export const userServiceSelector = selector(identitySelector<string>(), () => new UserService())
